import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSignalComponent } from './simple-icons-signal.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSignalComponent ],
    exports:      [ SimpleIconsSignalComponent ],
    bootstrap:    []
})
export class SimpleIconsSignalModule {}
